// extracted by mini-css-extract-plugin
export default {"searchContent":"SearchPage_searchContent__Ryquk","searchInfo":"SearchPage_searchInfo__moNsB","results":"SearchPage_results__jO+TM"};